export default __webpack_public_path__ + "static/0291-4f0df85588d81b157f478fab4383ac1d.png";